import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Monitora o scroll para mostrar/esconder o botão
    useEffect(() => {
        const handleScroll = () => {
            // Pega o scroll da janela, do elemento raiz ou do body
            const scrolled = window.scrollY ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            setIsVisible(scrolled > 300);
        };

        // Escuta o scroll na janela e na fase de captura
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Rolagem suave (mais elegante)
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`
                fixed bottom-5 right-5 z-50
                w-10 h-10 flex items-center justify-center
                bg-blue3 border-2 border-blue4 rounded-full text-white
                shadow-lg transition-all duration-500 ease-in-out
                hover:scale-110 hover:bg-blue4 active:scale-95
                ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}
            `}
            aria-label="Voltar ao topo"
        >
            <ChevronUp size={20} className="animate-bounce-subtle opacity-40" />
        </button>
    );
}